module.exports = __webpack_public_path__ + "img/logo3.e8ce3292.png";